import { DEFAULT_PAGINATION } from 'core/constants/pagination.constants';
import type { IDistributorsState } from './types';

export const SLICE_NAMESPACE = 'logistics/distributors';

export const initialState: IDistributorsState = {
  branchesList: {
    query: '',
    loading: {
      default: false,
      status: false,
    },
    branches: [],
    pagination: { ...DEFAULT_PAGINATION },
    form: {
      loading: false,
      success: false,
      errors: {},
    },
    customersExclusion: {
      loading: false,
      success: false,
      result: {
        date: '',
        filePath: '',
        templateUrl: '',
        userName: '',
        filename: '',
      },
    },
  },
};
